"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var ArticleVideoBlock = /*#__PURE__*/function () {
  function ArticleVideoBlock(component) {
    (0, _classCallCheck2["default"])(this, ArticleVideoBlock);
    this.dom = {
      $component: component,
      $foreground: component.querySelector('.js-article-video-block-foreground'),
      $background: component.querySelector('.js-article-video-block-background')
    }, this.state = {
      src: component.dataset.src ? component.dataset.src : false,
      loaded: false,
      loadedClass: 'is-loaded'
    };
    this.clickHandler = this.load.bind(this);
    this.mount();
  }

  (0, _createClass2["default"])(ArticleVideoBlock, [{
    key: "mount",
    value: function mount() {
      var dom = this.dom,
          state = this.state;
      console.log('ArticleVideoBlock : mount', this);
      dom.$foreground.addEventListener('click', this.clickHandler);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      var dom = this.dom,
          state = this.state;
      console.log('ArticleVideoBlock : unmount', this);
      dom.$foreground.removeEventListener('click', this.clickHandler);
    }
  }, {
    key: "load",
    value: function load(event) {
      var dom = this.dom,
          state = this.state;
      console.log('ArticleVideoBlock : load', this);

      if (!state.loaded && state.src) {
        var iframe = this.iframe(state.src);
        dom.$background.innerHTML = iframe;
        dom.$component.classList.add(state.loadedClass);
        state.loaded = true;
      }
    }
  }, {
    key: "iframe",
    value: function iframe(src) {
      console.log('VideoEmbed : iframe', this);
      return "<iframe src=\"".concat(src, "\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>");
    }
  }]);
  return ArticleVideoBlock;
}();

exports["default"] = ArticleVideoBlock;